import {inject, Injectable} from '@angular/core';
import {HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {MessageService} from 'primeng/api';
import {TranslationService} from './translation.service';


@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const messageService: MessageService = inject(MessageService);
    const translationService: TranslationService = inject(TranslationService);
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 400 && error.url?.includes("Identity/refresh")) {
          messageService.add({
            severity: "error",
            summary: translationService.translate("Authorization.TokenExpired"),
            closable: false
          })
        }
        else if(error.status === 401 && error.url?.includes("Identity/refresh")){
          messageService.add({
            severity: "error",
            summary: translationService.translate("Authorization.TokenInvalid"),
            closable: false
          })
        }
        else if (error.error instanceof Blob) {
          (<Blob>error.error).text().then(msg => {
            messageService.add({
              severity: "error",
              summary: translationService.translate(msg.replaceAll('"', '')),
              closable: false
            })
            console.log(msg);
          });
        }

        return throwError(() => error);
      })
    );
  }
}
